import React, { useRef, useState } from 'react';
import { useTranslation } from 'react-i18next';

import { formatWebsiteInfo, WebsiteInfo } from '../utils/formatWebsiteInfo';
import { parseLinks } from '../utils/normalizeUrl';
import { useRows } from '../utils/useRows';
import * as S from './LinkInput.styles';
import { MAX_CUSTOM_SOURCES } from './SourcesDraggableArea';

interface LinkInputProps {
  sourceCount: number;
  handleAddWebsites: (websites: WebsiteInfo[]) => void;
}

export const LinkInput = ({
  sourceCount,
  handleAddWebsites,
}: LinkInputProps) => {
  const { t } = useTranslation(['chat']);

  const inputRef = useRef<HTMLTextAreaElement>(null);

  const [inputValue, setInputValue] = useState<string>('');
  const { rows, updateRows } = useRows({
    value: inputValue,
    textAreaRef: inputRef,
    compactMode: true,
  });

  const addSources = (inputValue: string) => {
    if (sourceCount < MAX_CUSTOM_SOURCES) {
      const parsedLinks = parseLinks(inputValue).slice(
        0,
        MAX_CUSTOM_SOURCES - sourceCount
      );
      handleAddWebsites(formatWebsiteInfo(parsedLinks));

      setInputValue('');
    }
  };

  return (
    <S.LinkInputRoot>
      <S.InputLabel>{t('chat:trustedSources.modal.inputLabel')}</S.InputLabel>
      <S.InputWrapper>
        <S.TextareaElement
          as="textarea"
          rows={rows}
          value={inputValue}
          ref={inputRef}
          onChange={e => {
            updateRows(e);
            setInputValue(e.target.value);
          }}
          onKeyUp={e => {
            e.stopPropagation();
          }}
          onKeyDown={e => {
            if (e.key === 'Enter' && !e.shiftKey) {
              e.preventDefault();
              addSources(inputValue);
            }
          }}
          disabled={false}
        />
        <S.StyledButton
          onClick={() => addSources(inputValue)}
          iconName="ArrowUp"
          variant="empty"
          size="small"
          disabled={!inputValue}
        />
      </S.InputWrapper>
    </S.LinkInputRoot>
  );
};
